import { Outlet, useLoaderData, useRouteLoaderData } from '@remix-run/react';

import Breadcrumbs from '~/components/Breadcrumbs';
import { StandardLayout } from '~/layouts/StandardLayout';
import { type loader as rootLoader } from '~/root-loader';

import type { loader } from './loader';

export { handle } from './handle';
export { loader } from './loader';

export default function SportHome() {
	const rootLoaderData = useRouteLoaderData<typeof rootLoader>('root');
	if (!rootLoaderData) {
		throw new Error('Root loader data is missing');
	}

	const data = useLoaderData<typeof loader>();

	return (
		<StandardLayout {...rootLoaderData} {...data}>
			<Outlet context={data} />
			<Breadcrumbs />
		</StandardLayout>
	);
}
